import type { HyperguestSearchInput } from '@travel-planner/shared/schemas';
import { trpc } from '@/shared/api/trpc';

// Placeholder input used only as a query key when `enabled` is false — the
// procedure is never actually called with this shape.
const PLACEHOLDER: HyperguestSearchInput = {
  hotelIds: [''],
  checkIn: '1970-01-01',
  nights: 1,
  guests: 1,
};

// Search opts in to skipBatch because the upstream HG search round-trip can
// be slow and we don't want it to hold up unrelated batched queries.
export const useHyperguestSearch = (input: HyperguestSearchInput | null) =>
  trpc.hyperguestSearch.search.useQuery(input ?? PLACEHOLDER, {
    enabled: input !== null,
    trpc: { context: { skipBatch: true } },
  });
